const LEGACY_KEY = 'matrix-access-token';

function buildScopedKey(tenant?: string | null, userId?: string | null): string | null {
    if (!tenant || !userId) return null;
    return `matrix-access-token:${tenant}_${userId}`;
}

export function getStoredMatrixToken(tenant?: string | null, userId?: string | null): string | null {
    const scopedKey = buildScopedKey(tenant, userId);
    const scopedToken = scopedKey ? localStorage.getItem(scopedKey) : null;

    if (scopedToken) {
        return scopedToken;
    }

    const legacyToken = localStorage.getItem(LEGACY_KEY);
    if (legacyToken && scopedKey) {
        localStorage.setItem(scopedKey, legacyToken);
    }

    return legacyToken || null;
}

export function persistMatrixToken(token: string, tenant?: string | null, userId?: string | null): void {
    const scopedKey = buildScopedKey(tenant, userId);
    if (scopedKey) {
        localStorage.setItem(scopedKey, token);
    }
}

export function removeMatrixToken(tenant?: string | null, userId?: string | null): void {
    localStorage.removeItem(LEGACY_KEY);
    const scopedKey = buildScopedKey(tenant, userId);
    if (scopedKey) {
        localStorage.removeItem(scopedKey);
    }
}
